const statDonut = {
  init: function() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          return;
        }
        observer.unobserve(entry.target);
        let percentage = entry.target.dataset.percentage;
        this.animateDonut(this.animationEaseTiming, progress => {
          entry.target.style.setProperty('--donut-percentage', percentage * progress);
          entry.target.style.setProperty('--donut-text-percentage', '"' + Math.round(percentage * progress) + '%"');
        }, 1500);
      });
    });

    document.querySelectorAll('.stat-donut-section .stat-block.stat-block-animate').forEach(function(statBlock) {
      observer.observe(statBlock);
    });
  },
  animateDonut: function(timing, draw, duration) {
    let start;

    function step(time) {
      if (!start) {
        start = time;
      }
      // timeFraction goes from 0 to 1
      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) {
        timeFraction = 1;
      }
      // calculate the current animation state
      let progress = timing(timeFraction)

      draw(progress); // draw it

      if (timeFraction < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  },
  animationEaseTiming: timeFraction => (Math.sin((timeFraction - .5) * Math.PI) + 1) / 2,
};

document.addEventListener('DOMContentLoaded', function () {
  statDonut.init();
});
